import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EquipmentTemplateDto, CimClass, IconGroups } from '../../../models/network-structure.model';


@Component({
  selector: 'lib-icon-color',
  templateUrl: './icon-color.component.html',
  styleUrls: ['./icon-color.component.scss'],
  standalone: false
})
export class IconColorComponent implements OnChanges {
  @Input() equipment!: EquipmentTemplateDto;
  @Input() disabled: boolean = false;
  @Output() iconChanged = new EventEmitter<void>();

  selectedIconName: string = '';

  color: string = '#E89623';
  showPicker = false;
  iconGroups = IconGroups;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['equipment'] && this.equipment) {
      if (!this.equipment.visualizationConfiguration.color)
        this.equipment.visualizationConfiguration.color = this.color;
      else
        this.color = this.equipment.visualizationConfiguration.color;
      this.selectedIconName = this.equipment.visualizationConfiguration.symbol ?? '';
    }
  }

get iconsForCurrentClass(): string[] {
  if (!this.equipment || this.equipment.cimClass === undefined || this.equipment.cimClass === null) return [];
  let cimClassKey = this.equipment.cimClass;

  if (typeof cimClassKey === 'string') {
    cimClassKey = CimClass[cimClassKey as keyof typeof CimClass];
  }
  return this.iconGroups[cimClassKey] || [];
}

  selectIcon(icon: string) {
    this.selectedIconName = icon;
    this.equipment.visualizationConfiguration.symbol = icon;
    this.notifyEquipment();
  }
  
  togglePicker() {
    this.showPicker = !this.showPicker;
  }
  
  onColorChange(event: any) {
    this.color = event.color.hex;
    this.equipment.visualizationConfiguration.color = event.color.hex;
    this.notifyEquipment();
  }

  notifyEquipment() {
    this.iconChanged.emit();
  }
}
